module.exports = __webpack_public_path__ + "static/media/bolt.8c84989e.png";